import { cannedWorkPackageQuery } from "@common/api/quoting/canned"
import { useSuspenseQuery } from "@tanstack/react-query"
import {
  createFileRoute,
  Outlet,
  useNavigate,
  useRouter,
} from "@tanstack/react-router"
import { ListPage } from "@/components/layout/list-page"
import { PageContent } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { QuoteOverview } from "@/routes/_layout/templates/-components/quote-overview"
import {
  QUOTE_TABS,
  TemplateBar,
} from "@/routes/_layout/templates/-components/template-bar"

export const Route = createFileRoute(
  "/_layout/templates/quotes_/$packageId/overview",
)({
  component: TemplateQuoteOverviewPage,
})

function TemplateQuoteOverviewPage(): React.ReactElement {
  const { packageId } = Route.useParams()
  const { data: item } = useSuspenseQuery(
    cannedWorkPackageQuery({ package_id: packageId }),
  )
  const navigate = useNavigate()
  const router = useRouter()
  const showToast = useCustomToast()

  return (
    <ListPage
      toolbar={
        <TemplateBar
          name="Template quote"
          tabs={QUOTE_TABS}
          tab="overview"
          panelOpen={false}
          onSelect={(tab) =>
            tab !== "overview" &&
            navigate({
              to: "/templates/quotes/$packageId",
              params: { packageId },
              search: tab === "archived" ? { archived: true } : {},
            })
          }
        />
      }
      detail={<Outlet />}
    >
      <PageContent>
        <QuoteOverview
          key={`${item.id}-${item.archived_at}`}
          item={item}
          onSaved={(saved) => {
            showToast("Saved", `${saved.name} saved.`, "success")
            void router.invalidate()
          }}
          onRestored={() =>
            showToast("Restored", `${item.name} restored.`, "success")
          }
        />
      </PageContent>
    </ListPage>
  )
}
